import { render, staticRenderFns } from "./ManagementIndustry.vue?vue&type=template&id=901183a2&scoped=true&"
import script from "./ManagementIndustry.vue?vue&type=script&lang=js&"
export * from "./ManagementIndustry.vue?vue&type=script&lang=js&"
import style0 from "./ManagementIndustry.vue?vue&type=style&index=0&id=901183a2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901183a2",
  null
  
)

export default component.exports